import $ from 'jquery';

export default function(){
    var $category = $(".shopify-section.ingredients .ingredients_category .category_item");
    var $ingredients = $(".shopify-section.ingredients .ingredient_items");
    var $ingredient = $(".shopify-section.ingredients .ingredient_items .ingredient");
    var $ingredient_details = $(".shopify-section.ingredients .ingredient_details");
    var $ingredient_detail_item = $(".shopify-section.ingredients .ingredient_details .detail_item");

    var ingHtml;
    if($(window).width() < 980) {
      ingHtml = $ingredients.html();
    }
    initialIngSlider();

    $category.on('click', function(){

      if(!$(this).hasClass('active')) {
        var category = $(this).attr('data-category');
        $category.removeClass('active');
        $(this).addClass('active');


        if($(window).width() < 990) {
          $ingredients.removeClass('slick-initialized').removeClass('slick-slider').removeClass('slck-dotted').html(ingHtml);
        }


        $ingredient_detail_item.hide();
        $ingredient_details.css('height', 0);
        $ingredient.removeClass('active');
        $ingredient.find('a').removeClass('active');

        if(category == 'all') {
          $ingredients.find('.ingredient').removeAttr('data-hidden');
        }
        else {
          $ingredients.find('.ingredient').attr('data-hidden', 'true');
          $ingredients.find('.ingredient[data-category="'+ category +'"]').removeAttr('data-hidden');
        }

        initialIngSlider();

      }

    })

    function initialIngSlider(){
      if($(window).width() < 990) {
        $ingredients.find('[data-hidden]').remove();
        var slickHtml = '';
        var len = 30;
        var is_ended = false;
        $ingredients.find('.ingredient').each(function(idx){
          var _idx = idx % len;
          var $this = $(this);
          if(_idx == 0) {
            slickHtml += '<div class="slide_item_wrapper">';
          }
          slickHtml += '<div class="'+ $this.attr('class') +'" data-category="'+ $this.attr('data-category') +'">' + $this.html() + '</div>';
          if(_idx + 1 == len) {
            slickHtml += '</div>';
            is_ended = true;
          }
          else {
            is_ended = false;
          }
        })
        if(is_ended == false) {
          slickHtml += '</div>';
        }
        $ingredients.html(slickHtml);
        $ingredients.slick({
          slidesToShow: 1,
          arrows: false,
          dots: true
        })

        if($ingredients.find('.slide_item_wrapper').length > 1) {
          $("[data-swipe-ingredient-label]").removeClass('hidden');
        } else {
          $("[data-swipe-ingredient-label]").addClass('hidden');
        }
      }

    }


    $(document).on('click', '.ingredient a', function(){
      var is_active = true;
      if($(this).hasClass('active')){
        is_active = false;
      }
      $('.ingredient a').removeClass('active');
      $(this).addClass('active');
      var ingredient = $(this).attr('data-ingredient');
      $ingredient_detail_item.hide();

      var target_detail_item = $ingredient_details.find('.detail_item[data-ingredient="'+ ingredient +'"]');

      if(is_active == false) {
        $(this).removeClass('active');
        target_detail_item.slideUp(300);
        $ingredient_details.css('height', 0);
        return false;
      }

      var height = target_detail_item.outerHeight();
      $ingredient_details.css('height', height);
      target_detail_item.slideDown(300);

      var scrollTop = $(window).scrollTop() + $(window).height();
      var offsetTop = target_detail_item.offset().top + height;

      var spacing = 350;

      if($(window).width() < 980) {
        spacing = 180;
      }

      if(offsetTop > scrollTop) {
        $("html, body").animate({
          'scrollTop': offsetTop - height - spacing
        }, 300);
      }
    })


    var showArticles = 100;
    var articleHandle = 'all';
    var searchArticles = [];
    var searchHandle = '';
    var $read_more = $('.article_read_more');
    var $blog_categories = $(".shopify-section-blog-main .blog_header");
    var $blog_category = $(".shopify-section-blog-main .blog_header .blog_header_item");
    var $blog_category_tag = (".shopify-section-blog-main .blog_header .blog_header_item .blog_header_item_submenu a");

    var $blogs = $(".shopify-section-blog-main .blog_content");
    var $blog = $(".shopify-section-blog-main .blog_content article.post-cell");

    var $blogs_desc = $(".shopify-section-blog-main .blog_desc");

    var chandle = $(".shopify-section-blog-main .blog_header .blog_header_item.active").attr('data-type');
    var ihandle = $(".shopify-section-blog-main .blog_header .blog_header_item.active").attr('data-category');
    $blog.attr('data-hidden', 'true');
    $blogs.find('article.post-cell[data-handle="'+ chandle +'"]').removeAttr('data-hidden');

    if(chandle == 'all' || $('.blog_content.blog_content-show-hidden').length > 0 ) {
      $blog.removeAttr('data-hidden');
      $ingredient.removeAttr('data-hidden');
    }

    if (ihandle == '' || ihandle == undefined) {
      $blogs.removeAttr('style');
      $(".shopify-section-blog-main .swipe-text").removeAttr('style');
    } else {
      $blogs.attr('style', 'display: none !important;');
      $(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
    }

    var articleHtml;

    if($(window).width() < 768) {
      articleHtml = $(".shopify-section-blog-main [data-article-slider]").html();
      initialArticleSlider();
    }

    if($(window).width() < 768) {
     initialMobileHeaderSlider();
      $(".shopify-section-blog-main [data-mob-header-slider]").on('afterChange', function (event, slick, currentSlide, nextSlide) {
        var $container = $(".shopify-section-blog-main .blog_wrapper");
        var $this = $container.find('.blog_header .slick-active[data-slick-index="' + currentSlide + '"] .blog_header_item');
        var handle = $this.attr('data-type');
        $container.find('.blog_header .blog_header_item').removeClass('active');
        $this.addClass('active');

        if (handle != '' && $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').length > 0) {
          $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
          $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_header .blog_header_item').removeClass('active');
          $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_desc_wrap .blog_desc').removeClass('active');
          $container.find('.blog_desc_wrap .blog_desc[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
          $container.find('.blog_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

          $container.find('.ingredient_content .post-cell').attr('data-hidden', 'true');
          $container.find('.ingredient_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

          var ihandle = $this.attr('data-category');

          if (ihandle == '' || ihandle == undefined) {
            $blogs.removeAttr('style');
            $(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
            $(".shopify-section-blog-main .swipe-text").removeAttr('style');
          } else {
            $blogs.attr('style', 'display: none !important;');
            $(".shopify-section-blog-main .ingredient_details").removeAttr('style');
            $(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
          }
        }
      });
    } else {
      initialHeaderSlider();
      /*$(".shopify-section-blog-main [data-header-slider]").on('afterChange', function (event, slick, currentSlide, nextSlide) {
        var $container = $(".shopify-section-blog-main .blog_wrapper");
        var $this = $container.find('.blog_header .slick-active[data-slick-index="' + currentSlide + '"] .blog_header_item');
        var handle = $this.attr('data-type');
        $container.find('.blog_header .blog_header_item').removeClass('active');
        $this.addClass('active');

        if (handle != '' && $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').length > 0) {
          $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
          $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_header .blog_header_item').removeClass('active');
          $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_desc_wrap .blog_desc').removeClass('active');
          $container.find('.blog_desc_wrap .blog_desc[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
          $container.find('.blog_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

          $container.find('.ingredient_content .post-cell').attr('data-hidden', 'true');
          $container.find('.ingredient_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

          var ihandle = $this.attr('data-category');

          if (ihandle == '' || ihandle == undefined) {
            $blogs.removeAttr('style');
            $(".shopify-section-blog-main .9ingredient_details").attr('style', 'display: none !important;');
            $(".shopify-section-blog-main .swipe-text").removeAttr('style');
          } else {
            $blogs.attr('style', 'display: none !important;');
            $(".shopify-section-blog-main .ingredient_details").removeAttr('style');
            $(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
          }
        }
      });*/
    }

    function readmoreArticle() {
      var $articles = $blogs.find('article.post-cell');
      if (articleHandle != 'all') {
        $articles = $blogs.find('article.post-cell[data-handle="'+ articleHandle +'"]')
      }
      if (searchArticles.length > 0 && searchHandle) {
        $articles = searchArticles;
      }
      $articles.each(function(index){
        if (index < showArticles || index >= $articles.length / 2 && index - $articles.length / 2 < showArticles) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      if ($articles.length / 2 <= showArticles) {
        $read_more.hide();
      } else {
        $read_more.show();
      }
    }

    $read_more.click(function(e){
      e.preventDefault();
      showArticles += 20;
      readmoreArticle();
    });

    $('.recipe-blog-switcher_button').on('click', function(){
      $('.recipe-blog-switcher_button').removeClass('active');

      const switcherTarget = $(this).data('target');

      $(`.recipe-blog-switcher_button[data-target="${ switcherTarget }"]`).addClass('active');

      if(switcherTarget == 'recipes') {
        $('.blog_header').removeClass('hide');
        $('.blog_search_wrap').removeClass('hide');
        $('.blog_header-swipe').removeClass('hide');
        $('.blog_header_item--first').trigger('click');
      } else {
        $('.blog_header').addClass('hide');
        $('.blog_search_wrap').addClass('hide');
        $('.blog_header-swipe').addClass('hide');
        $('.blog_header_item--news').trigger('click');
      }
    })

    $blog_category.on('click', function(){
      var level = $(this).attr('data-level');

      if(! $(this).hasClass('active')) {
        if($(this).hasClass('has-sub-menu')){
          $(this).closest('.blog_header').addClass('blog_header_has-sub-menu');
        }
        else{
          $(this).closest('.blog_header').removeClass('blog_header_has-sub-menu');
        }
        $blog_category.removeClass('active');
        $($blog_category_tag).removeClass('active');
        $(this).addClass('active');
        var $container = $(this).closest('.blog_wrapper');
        $container.find('.ingredient_details .detail_item').attr('style', 'display: none;');
        $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');

        if($(window).width() < 768) {
          $(".shopify-section-blog-main [data-article-slider]").removeClass('slick-initialized').removeClass('slick-slider').removeClass('slck-dotted').html(articleHtml);
        }

        $blog = $(".shopify-section-blog-main .blog_content article.post-cell");
        $blog.attr('data-hidden', 'true');

        $ingredient = $(".shopify-section-blog-main .ingredient_content article.post-cell");
        $ingredient.attr('data-hidden', 'true');

        var handle = $(this).attr('data-type');
        articleHandle = handle;
        $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');

        if(handle == 'all') {
          $blog.removeAttr('data-hidden');
          $ingredient.removeAttr('data-hidden');
          $blogs_desc.removeClass('active');
        }
        else {
          $blogs.find('article.post-cell[data-handle="'+ handle +'"]').removeAttr('data-hidden');
          $ingredients.find('article.post-cell[data-handle="'+ handle +'"]').removeAttr('data-hidden');
          $blogs_desc.removeClass('active');
        }
        $('.shopify-section-blog-main .blog_desc[data-type="'+ handle +'"]').addClass('active');
        window.history.pushState('', '', location.protocol + '//' + location.host + location.pathname+'?'+handle);
      } else {
        //if($(window).width() > 767) {
          if($(this).hasClass('has-sub-menu')){
            $(this).closest('.blog_header').removeClass('blog_header_has-sub-menu');
            $(this).removeClass('active');
          }
       // }
      }

      var ihandle = $(this).attr('data-category');

      if (ihandle == '' || ihandle == undefined) {
        $blogs.removeAttr('style');
        $(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
        $(".shopify-section-blog-main .swipe-text").removeAttr('style');
      } else {
        $blogs.attr('style', 'display: none !important;');
        $(".shopify-section-blog-main .ingredient_details").removeAttr('style');
        $(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
      }

      $('.recipes-search-wrapper .recipes-search').val('');

      showArticles = 100;
      searchArticles = [];
      searchHandle = '';

      readmoreArticle();
    })

    $('body').on('click', $blog_category_tag, function(evnt){
      evnt.preventDefault();
      evnt.stopPropagation();
      evnt.stopImmediatePropagation();
      if(! $(this).hasClass('active')) {
        $($blog_category_tag).removeClass('active');
        $(this).addClass('active');
        $blog = $(".shopify-section-blog-main .blog_content article.post-cell");
        $blog.attr('data-hidden', 'true');

        $(this).closest('.blog_header').addClass('blog_header_has-sub-menu');
        $(this).closest('.blog_header_item').addClass('active');

        var handle = $(this).attr('data-type-tag');
        var menublog = $(this).closest('.blog_header_item').attr('data-type');

        $blogs.find('article.post-cell[data-handle="'+ menublog +'"][data-handle-tag*="'+ handle +'"]').removeAttr('data-hidden');
      }
    })

    if($(window).width() < 768) {

      var $target = $(".shopify-section-blog-main .blog_header .blog_header_item.active");
      $target.removeClass('active');
      $target.click();

    }

    function initialArticleSlider(){
      $(".shopify-section-blog-main [data-article-slider]").slick({
        slidesToShow: 1,
        arrows: false,
        dots: true
      })
    }

    function initialHeaderSlider(){
      $(".shopify-section-blog-main [data-header-slider]").slick({
        infinite: false,
        slidesToShow: $(window).width() > 1400? 6: 5,
        arrows: true,
        dots: false
      })
    }

    function initialMobileHeaderSlider(){
      $(".shopify-section-blog-main [data-mob-header-slider]").slick({
        infinite: false,
        arrows: false,
        dots: false,
        swipeToSlide: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        draggable: true,
        variableWidth: true
      })
    }

    $('.blog-tab').on('click', '.recipes-search-wrapper svg', function(){
      var $search = $(this).closest('.recipes-search-wrapper');
      var handle = $search.find('.recipes-search').val();
      handle = handle.trim().replaceAll(' ', '-');

      var $container = $(this).closest('.blog_wrapper');
      var activeCat = $(".shopify-section-blog-main .blog_header .blog_header_item.active").data('type');
      if (handle != '' && $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').length > 0) {
        $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
        $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');

        $container.find('.blog_header .blog_header_item').removeClass('active');
        $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').addClass('active');

        $container.find('.blog_desc_wrap .blog_desc').removeClass('active');
        $container.find('.blog_desc_wrap .blog_desc[data-type="' + handle + '"]').addClass('active');

        $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
        $container.find('.blog_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

        $container.find('.ingredient_content .post-cell').attr('data-hidden', 'true');
        $container.find('.ingredient_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

        var ihandle = $(this).attr('data-category');

        if (ihandle == '' || ihandle == undefined) {
          $blogs.removeAttr('style');
          $(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
          $(".shopify-section-blog-main .swipe-text").removeAttr('style');
        } else {
          $blogs.attr('style', 'display: none !important;');
          $(".shopify-section-blog-main .ingredient_details").removeAttr('style');
          $(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
        }
      }
      else {
        if( activeCat == 'all' ){
          $container.find('.blog_content .post-cell').removeAttr('data-hidden');
        }
        else{
          $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]').removeAttr('data-hidden');
        }
      }
      var foundSearch = '';
      handle.split(',').forEach(function(handle){
        foundSearch += '[data-search*="' + handle.toLowerCase() + '"]';
      });
      if( activeCat == 'all' ){
        var foundItem = $container.find('.blog_content .post-cell'+ foundSearch );
      }
      else {
        var foundItem = $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]'+ foundSearch );
      }
      if( foundItem.length > 0 ){
        $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
        foundItem.removeAttr('data-hidden');
      }
      if( foundItem.length == 0 && handle != '' ) {
        $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
      }
    });

    $('.blog-tab').on('keyup', '.recipes-search-wrapper .recipes-search',  function(event) {
        var handle = $(this).val();
        searchHandle = handle;
        handle = handle.trim().replaceAll(' ', '-');

        var $container = $(this).closest('.blog_wrapper');
        var activeCat = $(".shopify-section-blog-main .blog_header .blog_header_item.active").data('type');

        if (handle != '' && $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').length > 0) {
          $container.find('.blog_hero_wrapper .blog_hero').removeClass('active');
          $container.find('.blog_hero_wrapper .blog_hero[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_header .blog_header_item').removeClass('active');
          $container.find('.blog_header .blog_header_item[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_desc_wrap .blog_desc').removeClass('active');
          $container.find('.blog_desc_wrap .blog_desc[data-type="' + handle + '"]').addClass('active');

          $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
          $container.find('.blog_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

          $container.find('.ingredient_content .post-cell').attr('data-hidden', 'true');
          $container.find('.ingredient_content .post-cell[data-handle="' + handle + '"]').removeAttr('data-hidden');

          var ihandle = $(this).attr('data-category');

          if (ihandle == '' || ihandle == undefined) {
            $blogs.removeAttr('style');
            $(".shopify-section-blog-main .ingredient_details").attr('style', 'display: none !important;');
            $(".shopify-section-blog-main .swipe-text").removeAttr('style');
          } else {
            $blogs.attr('style', 'display: none !important;');
            $(".shopify-section-blog-main .ingredient_details").removeAttr('style');
            $(".shopify-section-blog-main .swipe-text").attr('style', 'display: none !important;');
          }
        }
        else {
          if( activeCat == 'all' ){
            $container.find('.blog_content .post-cell').removeAttr('data-hidden');
          }
          else{
            $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]').removeAttr('data-hidden');
          }
        }

        var foundSearch = '';
        handle.split(/[\s,-]+/).forEach(function(handle){
          foundSearch += '[data-search*="' + handle.toLowerCase() + '"]';
        });

        if( activeCat == 'all' ){
          var foundItem = $container.find('.blog_content .post-cell'+ foundSearch );
        }
        else {
          var foundItem = $container.find('.blog_content .post-cell[data-handle="' + activeCat + '"]'+ foundSearch );
        }
        if( foundItem.length > 0 ){
          $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
          foundItem.removeAttr('data-hidden');
        }
        if( foundItem.length == 0 && handle != '' ) {
          $container.find('.blog_content .post-cell').attr('data-hidden', 'true');
        }
        searchArticles = foundItem;
        readmoreArticle();
    });

    readmoreArticle();
}


